import { render } from "./AppPdf.vue?vue&type=template&id=10a720e0&scoped=true"
import script from "./AppPdf.vue?vue&type=script&lang=js"
export * from "./AppPdf.vue?vue&type=script&lang=js"

import "@/Common/Styles/appPdf.scss?vue&type=style&index=0&id=10a720e0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a720e0"]])

export default __exports__